import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams,  } from 'react-router-dom';

import LoginPanel from './LoginPanels/LoginPanel';
import PwChangePanel from './LoginPanels/PwChangePanel';
import SignUpPanel from './LoginPanels/SignUpPanel'; 
import FindIdPasswordPanel from './LoginPanels/FindIdPasswordPanel';
import MessagePanel from './LoginPanels/MessagePanel';

import { useSelector } from 'react-redux';

import { showToast } from './Common/Messages';

const Login = () => {
    const LoginStates = useSelector((state) => state.login);
    const loginSession = JSON.parse(window.localStorage.getItem("loginsession"));

    const [companyList, setCompanyList] = useState('');
    const [deptList, setDeptList] = useState('');

    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    useEffect(() => {
        getCompanyAndDeptList();
        if (params.panel != '' && params.panel != undefined) {
            setPanelType(params.panel);
            window.history.replaceState(null, '', '/Login')
        }
    }, []);
    const getCompanyAndDeptList = async () => {
        fetch('api/User/GetCompanyAndDeptListQuery?userId=-1', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        }).then((response) => response.json())
            .then((data) => {
                if (Object.keys(data).length != 0) {
                    let companyList = data.table ?? '', deptList = data.table1 ?? '';
                    setCompanyList(companyList);
                    setDeptList(deptList);
                }
            });
    };

    const setCookie = () => {
        if (LoginStates.userId == '' || LoginStates.sessionId == '') return;
        fetch('api/Login/SetCookie', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            credentials: 'include',
            body: JSON.stringify({userId: LoginStates.userId, sessionId: LoginStates.sessionId})
        }).then((response) => response.json())
            .then((data) => {
                //쿠키설정 완료
            });
    }
    
    //웹사이트 메인화면으로 경로 변경해주는 함수
    const routeChange = () => {
        const path = location.state?.pathName || '/';  
        // 로그인 성공 정보가 서버에 없으면 로컬에 복사하지 않는다.
        if (LoginStates.sessionId != '') {
            const autoLoginInfo = localStorage.getItem("isAutoLogin");
            if (autoLoginInfo != null && JSON.parse(autoLoginInfo).isAutoLogin) {
                setCookie();
            }

            if(loginSession == null)
                window.localStorage.setItem("loginsession", JSON.stringify({"userId":LoginStates.userId, "sessionId":LoginStates.sessionId}));            
            navigate(path);
        }
        // 로컬에 로그인 성공 정보가 없으면 메인으로 이동하지 않는다.
        if (LoginStates.sessionId == '' ) {
            window.localStorage.removeItem("loginsession")
            navigate(path);
        }
            
    };
    const [panelType, setPanelType] =useState('');
    const [result, setResult] =useState('');
    const [message, setMessage] =useState('');
    //렌더링될 때마다 돌며 패널을 바꿔주는 함수
    const actionResult = () => {
        if(loginSession != null) {
            return 'doMain';
        }
        if (result == '') {
            //result 값이 없는 경우는 화면 이벤트에 의한 Action
            return panelType;
        }
        else {
            if (result == 'Success Login') {
                showToast('success', message);
                return 'doMain';
            }
            else {
                //callBack에 의한 로그인 실패 로직.
                if (result == 'Fail Login') {
                    showToast('danger', message, 3000);
                    return 'loginAgain';
                }
                else if (result == 'Change Password') {
                    showToast('warning', message, 3000);
                    return 'changePassword';
                }
                else if (result == 'Over Failed Count') {                    
                    return 'showMessage';
                }
                else if (result == 'Success Finding') {
                    return 'showMessage';
                }
                else if (result == 'Success Changing Password') {
                    showToast('success',message);
                    return 'loginAgain';
                }
                else
                {   
                    return 'showMessage';
                }
            }
        }
    };

    const panelChange = (panelType) => {
        if (panelType == '' | panelType.toLowerCase() == 'loginagain') {
            return (
                <LoginPanel setPanelType={setPanelType} setResult={setResult} setMessage={setMessage} />
            );
        }
        else if (panelType.toLowerCase() == 'changepassword') {
            return (
                <PwChangePanel setPanelType={setPanelType} setResult={setResult} setMessage={setMessage}/>
            );
        }
        else if (panelType.toLowerCase() == 'signup') {
            return (
                <SignUpPanel companyList={companyList} deptList={deptList} setPanelType={setPanelType} setResult={setResult} setMessage={setMessage}/>
            );
        }
        else if (panelType.toLowerCase() == 'showmessage') {
            return (
                <MessagePanel setPanelType={setPanelType} />
            );
        }
        else if (panelType.toLowerCase() == 'findpassword') {
            return (
                <FindIdPasswordPanel setPanelType={setPanelType} setResult={setResult} setMessage={setMessage}/>
            );
        }
        else if (panelType.toLowerCase() == 'findinfo') {
            return (
                <FindIdPasswordPanel setPanelType={setPanelType} setResult={setResult} setMessage={setMessage}/>
            );
        }
        else if (panelType.toLowerCase() == 'domain') {
            routeChange();
        }
        else {
            return (
                <div>No Panel</div>
            );
        }

    };
    const doAction = actionResult();
    
    return (
        <Fragment>
            {panelChange(doAction)}
        </Fragment>
    );
};

export default Login;